<template>
  <div class="logistics-detail">
    <el-form ref="form" label-width="120px">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="物流方案名称">{{detailData.segmentLineName}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="编码">{{detailData.segmentLineCode}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="所属部门">{{detailData.lineDepartmentStr}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="货物">{{detailData.goodsStr}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="起始类型">
            {{logisticsVal.lineEndingAreaArr[detailData.lineStartingAreaType]}}
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="起始地">{{detailData.lineStartingAreaName}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="线路名称">{{detailData.lineNmae}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="运点距离">{{detailData.distanceTransPoint}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="目的类型">{{logisticsVal.lineEndingAreaArr[detailData.lineEndingAreaType]}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="目的地">{{detailData.lineEndingAreaName}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="预估成本单价（含税）">{{detailData.evaluation}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="计价单位">{{detailData.valuationStr}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="定价方式">{{logisticsVal.pricingWayArr[detailData.pricingWay]}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="状态">{{logisticsVal.statusArr[detailData.isEnabled]}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="预计时效（H）">{{detailData.estimateDay}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="备注">{{detailData.remark}}</el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item label="版本编码">{{detailData.code}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="更新时间">{{detailData.updateTime}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="创建人">{{detailData.createdUserName}}</el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="创建时间">{{detailData.createTime}}</el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-card class="form-card">
      <el-table
        :data="detailData.partitionList"
        ref="conditions"
        style="width: 100%">
        <el-table-column
          prop="sequence"
          label="顺序"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="taxPrice"
          label="含税单价"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="rateCharge"
          label="税率"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          :formatter="formatPartitionNum"
          label="分段环节"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          :formatter="formatTransport"
          label="服务方式"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="segmentStartingAreaName"
          label="起点"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="segmentEndingAreaName"
          label="终点"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="workAreaName"
          label="作业地点"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          label="起始点"
          :formatter="formatStationType"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
          prop="partitionRemark"
          label="备注"
          :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
    </el-card>
    <el-row>
      <el-button @click="handleClose">返 回</el-button>
    </el-row>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import logisticsVal from '../../logisticsVal'

export default {
  name: 'logisticsDetail',
  components: { },
  data () {
    return {
      id: this.$route.query.id,
      detailData: {},
      logisticsVal: logisticsVal,
      stationTypeArr: [
        { value: 1, label: '起点' },
        { value: 2, label: '途经点' },
        { value: 3, label: '终点' }
      ],
      transportArr: [
        ...Object.keys(logisticsVal.transportArr).map(key => ({
          label: logisticsVal.transportArr[key],
          value: -Number(key)
        })),
        ...Object.keys(logisticsVal.transportArr1).map(key => ({
          label: logisticsVal.transportArr1[key],
          value: Number(key)
        }))
      ],
      partitionNumArr: [
        { value: 1, label: '空箱集站' },
        { value: 2, label: '铁路调空箱' },
        { value: 3, label: '汽运提空' },
        { value: 4, label: '站内倒箱' },
        { value: 5, label: '站内装箱' },
        { value: 6, label: '铁路发运' },
        { value: 7, label: '铁路仓储' },
        { value: 8, label: '港口作业' },
        { value: 9, label: '外贸换装' },
        { value: 10, label: '末端汽运提重' },
        { value: 11, label: '末端加温' },
        { value: 12, label: '汽运返空' },
        { value: 13, label: '铁路返空' },
        { value: 14, label: '铁路到达' },
        { value: 15, label: '汽运提重' },
        { value: 16, label: '汽运卸重' }
      ]
    }
  },
  computed: {
  },
  mounted () {
    this.queryDetail()
  },
  methods: {
    ...mapActions(['getLogisticsSolutionDetail']),
    queryDetail () {
      this.getLogisticsSolutionDetail({ id: this.id }).then(res => {
        if (res.success) {
          this.detailData = res.data
        }
      })
    },
    handleClose () {
      this.$router.go(-1)
    },
    // 格式化起始点
    formatStationType (row) {
      const stationType = this.$lodash.find(this.stationTypeArr, { value: row.stationType }) || {}
      return stationType.label
    },
    formatPartitionNum (row) {
      const partitionNum = this.$lodash.find(this.partitionNumArr, { value: row.partitionNum }) || {}
      return partitionNum.label
    },
    formatTransport (row) {
      const transportMode = this.$lodash.find(this.transportArr, { value: row.transportMode }) || {}
      return transportMode.label
    }
  }
}
</script>
<style lang="scss" scoped>
.logistics-detail{
  .form-item-inline{
    display: inline-block;
  }
  .form-title {
    font-weight: bold;
    margin-bottom: 20px;
    font-size: 15px;
  }
}
</style>
